import { render, staticRenderFns } from "./ProjectBuyerStatisticsReportView.vue?vue&type=template&id=7f979e45&"
import script from "./ProjectBuyerStatisticsReportView.vue?vue&type=script&lang=ts&"
export * from "./ProjectBuyerStatisticsReportView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports